// eslint-disable-next-line import/no-anonymous-default-export
export default
{
    ID: 'forethought-widget-embed-script',
    PATH: 'https://solve-widget.forethought.ai/embed.js',
    API_KEY: 'c1bd2e68-6d9b-4da6-b5b4-c38dd6edc55f',
};
